export default "__VITE_ASSET__8976f48a__"